import { render, staticRenderFns } from "./EmployeeAddNew.vue?vue&type=template&id=e82e65ea&scoped=true&"
import script from "./EmployeeAddNew.vue?vue&type=script&lang=js&"
export * from "./EmployeeAddNew.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeAddNew.vue?vue&type=style&index=0&id=e82e65ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e82e65ea",
  null
  
)

export default component.exports